import template from './template.html'

function ContabilidadReporteisnGenerarComponent ($moment, ContabilidadReporteisn) {
  var $ctrl = this

  $ctrl.data = null
  $ctrl.procesando = false

  $ctrl.$onInit = function () {
    if ($ctrl.procesando) return

    $ctrl.procesando = true

    var idEmpresa = $ctrl.idEmpresa
    var fechaInicial = $moment($ctrl.fechaInicial).startOf('month').toDate()
    var fechaFinal = $moment($ctrl.fechaFinal).endOf('month').toDate()

    $ctrl.promise = ContabilidadReporteisn.get(idEmpresa, fechaInicial, fechaFinal)
      .then(function (response) {
        $ctrl.data = response.data
      })
      .catch(function (response) {
        $ctrl.error = response.data
      })
      .finally(function () {
        $ctrl.procesando = false
      })
  }

  $ctrl.cerrar = function () {
    $ctrl.onClose()
  }

  $ctrl.guardar = function () {
    if ($ctrl.data && $ctrl.data.save) {
      $ctrl.data.save()
    }
  }
}

angular.module('contabilidad.reporteisn')
  .component('contabilidadReporteisnGenerar', {
    controller: ContabilidadReporteisnGenerarComponent,
    template,
    bindings: {
      idEmpresa: '<',
      fechaInicial: '<',
      fechaFinal: '<',
      onClose: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/contabilidad/reporteisn/components/generar/component.js